import { type FC, type SVGProps } from 'react';

import { FacebookFooter, Instagram, Tiktok, X, YoutubeFooter } from '../../primitives/icon/icons';
import { type SocialLink } from '../footer/types';

type SocialLinkTemplate = {
  SvgIcon: FC<SVGProps<SVGSVGElement>>;
  linkLabel: string;
  name: string;
};

const SOCIAL_LINK_TEMPLATES: SocialLinkTemplate[] = [
  {
    SvgIcon: YoutubeFooter,
    linkLabel: 'CX_SOCIAL_YOUTUBE_ACCOUNT',
    name: 'youtube',
  },
  {
    SvgIcon: Tiktok,
    linkLabel: 'CX_SOCIAL_TIKTOK_ACCOUNT',
    name: 'tiktok',
  },
  {
    SvgIcon: FacebookFooter,
    linkLabel: 'CX_SOCIAL_FACEBOOK_ACCOUNT',
    name: 'facebook',
  },
  {
    SvgIcon: Instagram,
    linkLabel: 'CX_SOCIAL_INSTAGRAM_ACCOUNT',
    name: 'instagram',
  },
  {
    SvgIcon: X,
    linkLabel: 'CX_SOCIAL_X_ACCOUNT',
    name: 'x',
  },
];

// i18next returns the key itself when a translation is missing; treat that as "platform not configured".
export const getSocialLinks = (t: (key: string) => string): SocialLink[] =>
  SOCIAL_LINK_TEMPLATES.flatMap(({ SvgIcon, linkLabel, name }) => {
    const href = t(linkLabel);
    return href && href !== linkLabel ? [{ SvgIcon, href, name }] : [];
  });
